import { loadMe, me, send, setToken } from "../api";
import { $, button, field, flash, form, h, input, show, statusChip, table, td, th, view } from "../ui";
import { testAlarmButton } from "./alarms";

export async function mePage() {
  const m = me();
  if (!m) return;
  const key = input({ placeholder: m.bark_key_set ? `set, ends in …${m.bark_hint}; paste a new one to replace it` : "Paste your Bark device key", autocomplete: "off", maxlength: "64", "aria-label": "Bark key" });
  const barkForm = form(
    "fields",
    async () => {
      const v = key.value.trim();
      await send("PUT", "/v1/admin/me", { bark_key: v });
      await loadMe();
      await mePage();
      flash(v ? "Bark key saved. Send yourself a test alarm to check it." : "Bark key removed.");
    },
    field("Bark device key", key, true),
    h(
      "div",
      { class: "actions" },
      h("button", { class: "btn small primary", type: "submit" }, "Save key"),
      m.bark_key_set
        ? button("Remove the key", "btn small plain", async () => {
            try {
              await send("PUT", "/v1/admin/me", { bark_key: "" });
              await loadMe();
              await mePage();
              flash("Bark key removed.");
            } catch (e) {
              flash((e as Error).message, true);
            }
          })
        : null,
    ),
  );
  show(
    m.name || "Me",
    "Your staff account on this site.",
    table(
      [th("Field"), th("Value")],
      [
        h("tr", null, td("Role"), h("td", null, statusChip(m.role))),
        h("tr", null, td("Email"), td(m.email ?? "—")),
        h("tr", null, td("Account id"), td(m.account_id, "mono")),
        h("tr", null, td("Bark key"), td(m.bark_key_set ? `set, ends in …${m.bark_hint}` : "not set")),
      ],
      "",
    ),
    h("h2", null, "Alarms"),
    h("p", { class: "muted" }, "Owners and admins get every alarm by push (the Luwu app on your phone), by email, and by Bark if a key is set. The key is kept on the server and never shown again; this page only says whether one is set."),
    barkForm,
    h("div", { class: "actions" }, testAlarmButton()),
    h("h2", null, "Sign out"),
    h("p", { class: "muted" }, "Drops this site's token on this browser. Your Luwu app and other sessions stay signed in."),
    h(
      "div",
      { class: "actions" },
      button("Sign out", "btn small plain", () => {
        setToken(null);
        $("nav-staff").hidden = true;
        view("email");
      }),
    ),
  );
}
